import { ArrowLeft, ArrowRight, Loader2 } from "lucide-react";

export function Progress({ step }) {
    return (
        <div className="mb-8" data-testid="ic-progress">
            <div className="flex items-center justify-between mono-label text-moss">
                <span>The Investor Circle</span>
                <span data-testid="ic-progress-label">Step {step} of 3</span>
            </div>
            <div className="mt-3 grid grid-cols-3 gap-1.5" aria-hidden="true">
                {[1, 2, 3].map((n) => <span key={n} className={`h-[3px] rounded-full transition-colors duration-500 ${n <= step ? "bg-forest" : "bg-forest/15"}`} />)}
            </div>
        </div>
    );
}

export function StepHead({ title, sub }) {
    return (
        <div className="mb-7">
            <h2 className="font-serif text-3xl md:text-[2.4rem] leading-[1.05] text-forest tracking-tight" tabIndex={-1} data-ic-heading>{title}</h2>
            <p className="mt-2 text-muted_text">{sub}</p>
        </div>
    );
}

export function Field({ label, htmlFor, children }) {
    return (
        <div>
            <label htmlFor={htmlFor} className="block text-sm text-ink mb-2">{label}</label>
            {children}
        </div>
    );
}

export function Option({ selected, onClick, children, testid, compact }) {
    return (
        <button type="button" role="radio" aria-checked={selected} onClick={onClick} data-testid={testid}
                className={`w-full text-left rounded-xl border transition-[background-color,border-color,color] duration-200 ${compact ? "px-4 py-3 text-sm" : "px-5 py-4 text-[15px]"} ${selected ? "bg-forest text-cream border-forest" : "bg-white/50 border-hairline text-ink hover:border-forest/50"}`}>
            {children}
        </button>
    );
}

export function Consent({ checked, onChange, children, testid }) {
    return (
        <label className="flex items-start gap-3 text-sm text-muted_text leading-relaxed cursor-pointer">
            <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-1 h-4 w-4 shrink-0 accent-forest" data-testid={testid} />
            <span>{children}</span>
        </label>
    );
}

export function ErrorLine({ error }) {
    return <p role="alert" aria-live="polite" className={`text-sm text-[#9A3B2E] ${error ? "" : "sr-only"}`} data-testid="ic-error">{error}</p>;
}

export function NextButton({ busy, children, testid }) {
    return (
        <button type="submit" disabled={busy} data-testid={testid}
                className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 rounded-full bg-forest text-cream hover:bg-forest-hover px-8 py-4 text-sm font-medium transition-colors disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}{children}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </button>
    );
}

export function BackButton({ onClick }) {
    return (
        <button type="button" onClick={onClick} data-testid="ic-back" className="inline-flex items-center gap-2 px-2 py-4 text-sm text-muted_text hover:text-forest transition-colors">
            <ArrowLeft className="h-4 w-4" /> Back
        </button>
    );
}
